import { useMemo, useState } from "react"

import walletIcon from "#/assets/wallet.svg"
import zapIcon from "#/assets/zap-green.svg"
import TooltipLabel from "#/shared/components/TooltipLabel"
import { trimAddress } from "#/shared/utils"

import WithdrawalModalTag from "./WithdrawalModalTag"

type WithdrawalModalAddressTagProps = {
  shouldEditDestination: boolean
  customDestination: string | null
  destinationLabel: string | null
  onClick: () => void
}

export default function WithdrawalModalAddressTag({
  shouldEditDestination,
  customDestination,
  destinationLabel,
  onClick,
}: WithdrawalModalAddressTagProps) {
  const [isHoveringDestinationButton, setIsHoveringDestinationButton] =
    useState(false)

  const destinationButtonLabel = useMemo(() => {
    if (!customDestination) {
      return "Add address"
    }
    return isHoveringDestinationButton
      ? "Edit address"
      : trimAddress(customDestination)
  }, [customDestination, isHoveringDestinationButton])

  if (shouldEditDestination) {
    return (
      <WithdrawalModalTag
        icon={walletIcon}
        width="150px"
        backgroundColor={
          customDestination ? "green.highlight" : "primary.red.100"
        }
        backgroundHoverColor={
          customDestination ? "primary.red.100" : "primary.red.70"
        }
        onClick={onClick}
        onMouseEnter={() => setIsHoveringDestinationButton(true)}
        onMouseLeave={() => setIsHoveringDestinationButton(false)}
      >
        <TooltipLabel value={customDestination} width="fit-content">
          {destinationButtonLabel}
        </TooltipLabel>
      </WithdrawalModalTag>
    )
  }

  return (
    <WithdrawalModalTag icon={zapIcon}>
      {trimAddress(destinationLabel ?? "")}
    </WithdrawalModalTag>
  )
}
